import { render, staticRenderFns } from "./ConfigMapas.vue?vue&type=template&id=5b028ef8&scoped=true"
import script from "./ConfigMapas.vue?vue&type=script&lang=js"
export * from "./ConfigMapas.vue?vue&type=script&lang=js"
import style0 from "./ConfigMapas.vue?vue&type=style&index=0&id=5b028ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b028ef8",
  null
  
)

export default component.exports